import img from "../US_img/1Plafond tendu circulaire avec éclairage LED intégré, design architectural moderne pour espace professionnel – UNIK SYSTEM.webp"; // adapte l’image
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsLightRetroeclairage() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>LIGHT</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">Avec rétroéclairage</h1>

          <p data-aos="fade-up">
            Des plafonds lumineux pour des lieux publics ou privés,
            créant des ambiances originales, chaleureuses et design.
            Idéals pour les espaces de vie, de détente ou d’accueil.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-light.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Light plafond rétroéclairé" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US LIGHT ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US LIGHT propose des plafonds et murs lumineux intégrant un
            système de rétroéclairage LED. Cette solution permet de créer
            une lumière diffuse et homogène tout en valorisant l’architecture
            intérieure.
          </p>

          <p data-aos="fade-up">
            Idéal pour les hôtels, spas, commerces et espaces résidentiels,
            le système US LIGHT combine design, confort visuel et performance
            énergétique.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="✨"
            title="Ambiance chaleureuse"
            text="Création d’une atmosphère douce et relaxante."
          />
          <Feature
            icon="💡"
            title="Éclairage homogène"
            text="Diffusion lumineuse uniforme sans zones d’ombre."
          />
          <Feature
            icon="🎨"
            title="Design esthétique"
            text="Intégration élégante dans tous types d’espaces."
          />
          <Feature
            icon="🔌"
            title="Câbles dissimulés"
            text="Installation propre avec dissimulation des équipements."
          />
          <Feature
            icon="⚡"
            title="LED basse consommation"
            text="Solution lumineuse économique et durable."
          />
          <Feature
            icon="🛠️"
            title="Maintenance facile"
            text="Accès technique simple et composants remplaçables."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toile translucide haute diffusion</li>
          <li>Système LED rétroéclairé</li>
          <li>Éclairage homogène sans éblouissement</li>
          <li>Structure aluminium technique</li>
          <li>Compatible plafonds et murs lumineux</li>
          <li>Faible consommation énergétique</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Hôtels",
            "Spas",
            "Restaurants",
            "Commerces",
            "Bureaux",
            "Espaces résidentiels",
            "Centres commerciaux",
            "Espaces publics",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Créez des ambiances lumineuses uniques</h2>
        <p>Nos solutions US LIGHT s’adaptent à tous vos projets.</p><br/>
        <a href="/contact" className="btn-primarya">Contactez-nous</a>
      </section>

    </div>
  );
}
